import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const GoLiveConfirmModal = ({ show, onClose, onConfirm, loading }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Finalizar modo de prueba')} size="m">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Al finalizar el periodo de prueba, tu tienda se activará por completo, lo que permitirá a los clientes solicitar devoluciones y cambios a través de tu portal. Esta acción no se puede deshacer.'
          )}
        </Text>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
            loadingLabel={t('Confirmar')}
            defaultLabel={t('Confirmar')}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default GoLiveConfirmModal
